try {
// ── LIVE PRICES ──
const METALS=[
  {id:'gold',      lbl:'Gold',      unit:'troy oz', base:4020,   sw:''},
  {id:'silver',    lbl:'Silver',    unit:'troy oz', base:56.80,  sw:'silver-sw'},
  {id:'platinum',  lbl:'Platinum',  unit:'troy oz', base:2595,   sw:'plat-sw'},
  {id:'palladium', lbl:'Palladium', unit:'troy oz', base:1265,   sw:'pall-sw'},
  {id:'rhodium',   lbl:'Rhodium',   unit:'troy oz', base:10250,  sw:''},
  {id:'iridium',   lbl:'Iridium',   unit:'troy oz', base:4600,   sw:''},
  {id:'ruthenium', lbl:'Ruthenium', unit:'troy oz', base:490,    sw:''},
  {id:'osmium',    lbl:'Osmium',    unit:'troy oz', base:400,    sw:''},
  {id:'copper',    lbl:'Copper',    unit:'lb',      base:4.65,   sw:''},
  {id:'silver925', lbl:'Silver .925 (Sterling)', unit:'troy oz', base:52.54, sw:'silver-sw'},
  {id:'gold14k',   lbl:'Gold 14K',  unit:'dwt',     base:117.59, sw:''},
  {id:'gold18k',   lbl:'Gold 18K',  unit:'dwt',     base:150.75, sw:''},
  {id:'gold10k',   lbl:'Gold 10K',  unit:'dwt',     base:83.82,  sw:''},
  {id:'gold24k',   lbl:'Gold 24K',  unit:'dwt',     base:200.98, sw:''},
];
const PR={};
METALS.forEach(m=>{ PR[m.id]={p:m.base, c:(Math.random()-0.48)*m.base*0.012}; });

function fmt(id,v){
  if(id==='copper') return '$'+v.toFixed(2);
  return '$'+v.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}

// Show these spot metals in the ticker (no karat/sterling variants)
const TICKER_IDS = ['gold','silver','platinum','palladium','rhodium'];

function buildTickerHTML(){
  // Always show all 5 main spot metals — gold/silver/platinum/palladium come live from API,
  // rhodium uses a regularly-updated base value (gold-api doesn't return it)
  const live = METALS.filter(m => TICKER_IDS.includes(m.id));
  if(live.length === 0) return '';
  // Repeat spot metals 5x so the ticker strip is wide enough for seamless looping
  const repeated = [];
  for(let i=0; i<5; i++) repeated.push(...live);
  const items = repeated.map(m=>{
    const d=PR[m.id]; const up=d.c>=0;
    const pct=Math.abs(d.c/d.p*100).toFixed(2);
    const arrow=up?'▲':'▼';
    const cls=up?'up':'dn';
    return `<div class="ticker-item">
      <span class="ti-metal-name">${m.lbl}</span>
      <span class="ti-price">${fmt(m.id,d.p)}</span>
      <span class="ti-change ${cls}">${arrow} ${pct}%</span>
      <span class="ti-unit">/ ${m.unit}</span>
    </div>`;
  }).join('');
  return items;
}

function renderAll(){
  // Sliding ticker — fill both halves with identical content for seamless infinite loop
  const html=buildTickerHTML();
  const ta=document.getElementById('ticker-items-a');
  const tb=document.getElementById('ticker-items-b');
  if(ta) ta.innerHTML=html;
  if(tb) tb.innerHTML=html;

  // Hero price list — show only main 4 spot metals
  const heroMetals=METALS.slice(0,4);
  const hpl=document.getElementById('hero-price-list');
  if(hpl) hpl.innerHTML=heroMetals.map(m=>{
    const d=PR[m.id]; const up=d.c>=0;
    const pct=Math.abs(d.c/d.p*100).toFixed(2);
    return `<div class="price-row">
      <div class="pr-left"><div class="pr-swatch ${m.sw}"></div><div><div class="pr-name">${m.lbl}</div><div class="pr-unit">Per ${m.unit}</div></div></div>
      <div class="pr-right"><span class="pr-price">${fmt(m.id,d.p)}</span><span class="pr-chg ${up?'up':'dn'}">${up?'▲':'▼'} ${pct}%</span></div>
    </div>`;
  }).join('');

  // Date
  const d=new Date();
  const pd=document.getElementById('pc-date');
  if(pd) pd.textContent=d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
}

function tick(){
  METALS.forEach(m=>{
    // Metals with confirmed live API data are NEVER animated or clamped —
    // the ticker must show the real fetched price until the next fetch.
    if(window.LIVE_METALS && window.LIVE_METALS.has(m.id)) return;
    const t=(Math.random()-0.49)*m.base*0.0007;
    PR[m.id].p=Math.max(m.base*0.88, PR[m.id].p+t);
    PR[m.id].c=PR[m.id].c*0.95+t;
  });
  renderAll();
}
renderAll();
setInterval(tick,4200);

// ── LIVE PRICE FETCHER ──
// gold-api.com — free, no API key, CORS enabled, confirmed working
// Fetches XAU, XAG, XPT, XPD in parallel then updates all displays

const OZperDWT = 1/20; // 1 troy oz = 20 pennyweights

async function fetchMetal(symbol){
  const r = await fetch(`https://api.gold-api.com/price/${symbol}`, {
    signal: AbortSignal.timeout(7000)
  });
  if(!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

// Track which metals have confirmed live API data — others get hidden from ticker
window.LIVE_METALS = window.LIVE_METALS || new Set();

async function fetchLivePrices(){
  try {
    // Fetch all metals we want to support in parallel
    const [gold, silver, platinum, palladium, rhodium] = await Promise.allSettled([
      fetchMetal('XAU'),
      fetchMetal('XAG'),
      fetchMetal('XPT'),
      fetchMetal('XPD'),
      fetchMetal('XRH')
    ]);

    let updated = false;

    if(gold.status === 'fulfilled' && gold.value.price > 500){
      const g = gold.value.price;
      PR.gold.p     = g;
      PR.gold24k.p  = g * 0.9999 * OZperDWT;
      PR.gold18k.p  = g * 0.750  * OZperDWT;
      PR.gold14k.p  = g * 0.585  * OZperDWT;
      PR.gold10k.p  = g * 0.417  * OZperDWT;
      window.LIVE_METALS.add('gold');
      window.LIVE_METALS.add('gold24k');
      window.LIVE_METALS.add('gold18k');
      window.LIVE_METALS.add('gold14k');
      window.LIVE_METALS.add('gold10k');
      updated = true;
      console.log('✓ Gold: $' + g.toFixed(2));
    }
    if(silver.status === 'fulfilled' && silver.value.price > 1){
      const s = silver.value.price;
      PR.silver.p    = s;
      PR.silver925.p = s * 0.925;
      window.LIVE_METALS.add('silver');
      window.LIVE_METALS.add('silver925');
      updated = true;
      console.log('✓ Silver: $' + s.toFixed(2));
    }
    if(platinum.status === 'fulfilled' && platinum.value.price > 100){
      PR.platinum.p = platinum.value.price;
      window.LIVE_METALS.add('platinum');
      updated = true;
      console.log('✓ Platinum: $' + platinum.value.price.toFixed(2));
    }
    if(palladium.status === 'fulfilled' && palladium.value.price > 100){
      PR.palladium.p = palladium.value.price;
      window.LIVE_METALS.add('palladium');
      updated = true;
      console.log('✓ Palladium: $' + palladium.value.price.toFixed(2));
    }
    if(rhodium.status === 'fulfilled' && rhodium.value.price > 100){
      PR.rhodium.p = rhodium.value.price;
      window.LIVE_METALS.add('rhodium');
      updated = true;
      console.log('✓ Rhodium: $' + rhodium.value.price.toFixed(2));
    }

    if(updated) renderAll();

  } catch(e){
    console.log('Live price fetch error:', e.message);
  }
}

// Fetch on load, then every 60 seconds
fetchLivePrices();
setInterval(fetchLivePrices, 60000);

// ── WHAT WE BUY ──
let activeDet=null;
function togDet(id,cardEl){
  const isOpen=activeDet===id;

  // Close any open panel
  if(activeDet){
    const old=document.getElementById('det-'+activeDet);
    if(old){ old.classList.remove('active'); old.style.display='none'; }
    document.querySelectorAll('.cat-card').forEach(c=>c.classList.remove('active'));
    activeDet=null;
  }

  if(!isOpen){
    activeDet=id;
    cardEl.classList.add('active');
    const panel=document.getElementById('det-'+id);
    if(panel){
      panel.style.display='block';
      // Force reflow then add active for animation
      panel.offsetHeight;
      panel.classList.add('active');
      setTimeout(()=>panel.scrollIntoView({behavior:'smooth',block:'nearest'}),80);
    }
  }
}
function closeDet(id){
  const panel=document.getElementById('det-'+id);
  if(panel){ panel.classList.remove('active'); panel.style.display='none'; }
  document.querySelectorAll('.cat-card').forEach(c=>c.classList.remove('active'));
  activeDet=null;
}

// ── TABS ──
// ── SCRAP CALCULATORS ──
function calcGold() {
  const karat = parseFloat(document.getElementById('calc-gold-karat').value) || 0;
  const unit = parseFloat(document.getElementById('calc-gold-unit').value) || 1;
  const weight = parseFloat(document.getElementById('calc-gold-weight').value) || 0;
  const res = document.getElementById('calc-gold-result');
  const det = document.getElementById('calc-gold-detail');
  if (!weight || weight <= 0) { res.textContent = '—'; det.textContent = ''; return; }
  const goldSpot = (PR && PR.gold && PR.gold.p) ? PR.gold.p : 3200;
  const weightGrams = weight * unit;
  const weightTroyOz = weightGrams / 31.1035;
  const pureGoldOz = weightTroyOz * karat;
  const meltValue = pureGoldOz * goldSpot;
  const low = meltValue * 0.75;
  const high = meltValue * 0.90;
  res.textContent = '$' + low.toFixed(0) + ' – $' + high.toFixed(0);
  det.innerHTML = 'Melt value: $' + meltValue.toFixed(2) +
    '<br>Gold spot: $' + goldSpot.toFixed(2) + '/ozt' +
    '<br>Pure gold: ' + pureGoldOz.toFixed(4) + ' ozt (' + (weightGrams * karat).toFixed(2) + 'g)' +
    '<br>Range: 75–90% of melt';
}

function calcSilver() {
  document.getElementById('calc-silver-face').value = '';
  const purity = parseFloat(document.getElementById('calc-silver-type').value) || 0;
  const unit = parseFloat(document.getElementById('calc-silver-unit').value) || 1;
  const weight = parseFloat(document.getElementById('calc-silver-weight').value) || 0;
  const res = document.getElementById('calc-silver-result');
  const det = document.getElementById('calc-silver-detail');
  if (!weight || weight <= 0) { res.textContent = '—'; det.textContent = ''; return; }
  const silverSpot = (PR && PR.silver && PR.silver.p) ? PR.silver.p : 32;
  const weightGrams = weight * unit;
  const weightTroyOz = weightGrams / 31.1035;
  const pureSilverOz = weightTroyOz * purity;
  const meltValue = pureSilverOz * silverSpot;
  const low = meltValue * 0.80;
  const high = meltValue * 0.95;
  res.textContent = '$' + low.toFixed(2) + ' – $' + high.toFixed(2);
  det.innerHTML = 'Melt value: $' + meltValue.toFixed(2) +
    '<br>Silver spot: $' + silverSpot.toFixed(2) + '/ozt' +
    '<br>Pure silver: ' + pureSilverOz.toFixed(4) + ' ozt' +
    '<br>Range: 80–95% of melt';
}

function calcSilverFace() {
  document.getElementById('calc-silver-weight').value = '';
  const face = parseFloat(document.getElementById('calc-silver-face').value) || 0;
  const res = document.getElementById('calc-silver-result');
  const det = document.getElementById('calc-silver-detail');
  if (!face || face <= 0) { res.textContent = '—'; det.textContent = ''; return; }
  const silverSpot = (PR && PR.silver && PR.silver.p) ? PR.silver.p : 32;
  const pureSilverOz = face * 0.715; // standard 90% coin silver factor
  const meltValue = pureSilverOz * silverSpot;
  const low = meltValue * 0.80;
  const high = meltValue * 0.95;
  res.textContent = '$' + low.toFixed(2) + ' – $' + high.toFixed(2);
  det.innerHTML = 'Face value: $' + face.toFixed(2) +
    '<br>Silver content: ' + pureSilverOz.toFixed(4) + ' ozt (0.715× face)' +
    '<br>Silver spot: $' + silverSpot.toFixed(2) + '/ozt' +
    '<br>Melt value: $' + meltValue.toFixed(2) + ' · Range: 80–95%';
}

function togFaq(btn) {
  const item = btn.closest('.faq-item');
  const ans = item.querySelector('.faq-a');
  const isOpen = btn.classList.contains('open');
  // close all
  document.querySelectorAll('.faq-q.open').forEach(function(q) {
    q.classList.remove('open');
    q.closest('.faq-item').querySelector('.faq-a').classList.remove('open');
  });
  if (!isOpen) {
    btn.classList.add('open');
    ans.classList.add('open');
  }
}

function swTab(id,btn){
  document.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
  document.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('tab-'+id).classList.add('active');
  // Scroll active btn into view in sidebar (both vertical and horizontal)
  try { btn.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'}); } catch(e){}
}

// ── GUIDED QUOTE FLOW ──
const KARAT_OPTIONS = {
  Gold: [
    { label: '24K · 999', val: '24K (.999 fine)' },
    { label: '23K · Baht', val: '23K (Thai Baht)' },
    { label: '22K · 917', val: '22K' },
    { label: '18K · 750', val: '18K' },
    { label: '14K · 585', val: '14K' },
    { label: '10K · 417', val: '10K' },
    { label: '9K · 375', val: '9K' },
    { label: 'Gold Filled', val: 'Gold Filled (GF)' },
    { label: 'Not Sure', val: 'Unknown karat' },
  ],
  Silver: [
    { label: '.999 Fine', val: '.999 Fine Silver' },
    { label: '.925 Sterling', val: '.925 Sterling' },
    { label: '90% Coin', val: '90% Coin Silver (pre-1965)' },
    { label: '80% Canadian', val: '80% Silver (Canadian)' },
    { label: '72% Mexican', val: '72% Silver (Mexican Peso)' },
    { label: '40% Kennedy', val: '40% Silver (Kennedy Half)' },
    { label: 'Not Sure', val: 'Unknown purity' },
  ],
  'Platinum / PGMs': [
    { label: 'Pt950 Jewelry', val: 'Platinum 950 jewelry' },
    { label: 'Pt900 Jewelry', val: 'Platinum 900 jewelry' },
    { label: 'Pt850 Jewelry', val: 'Platinum 850 jewelry' },
    { label: 'Platinum Coins / Bars', val: 'Platinum bullion coins or bars' },
    { label: 'Platinum Lab / Industrial', val: 'Platinum lab or industrial scrap (crucibles, wire, sheet)' },
    { label: 'Palladium Jewelry', val: 'Palladium jewelry' },
    { label: 'Palladium Dental', val: 'Palladium dental alloy scrap' },
    { label: 'Palladium Coins / Bars', val: 'Palladium bullion coins or bars' },
    { label: 'Palladium Industrial', val: 'Palladium industrial scrap (catalysts, MLCCs)' },
    { label: 'Rhodium', val: 'Rhodium (industrial, catalysts, sweeps)' },
    { label: 'Iridium', val: 'Iridium (crucibles, lab equipment)' },
    { label: 'PGM Mixed / Not Sure', val: 'Mixed PGM scrap or not sure' },
  ],
};

const WEIGHT_METALS = ['Gold','Silver','Platinum'];
let qMetal = '', qKarat = '';

function selectMetal(btn) {
  document.querySelectorAll('.qmetal-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  qMetal = btn.dataset.metal;
  qKarat = '';

  const karatRow = document.getElementById('qflow-karat-row');
  const weightRow = document.getElementById('qflow-weight-row');
  const notesRow = document.getElementById('qflow-notes-row');
  const karatGrid = document.getElementById('qflow-karat-grid');
  const karatLabel = document.getElementById('qflow-karat-label');

  if (KARAT_OPTIONS[qMetal]) {
    karatGrid.innerHTML = '';
    const labels = { Silver: 'Select Purity', 'Platinum / PGMs': 'Select Type / Metal' };
    karatLabel.textContent = labels[qMetal] || 'Select Karat';
    KARAT_OPTIONS[qMetal].forEach(function(opt) {
      const b = document.createElement('button');
      b.className = 'qkarat-btn'; b.textContent = opt.label; b.dataset.val = opt.val;
      b.onclick = function() { selectKarat(b); };
      karatGrid.appendChild(b);
    });
    karatRow.style.display = 'block';
    weightRow.style.display = 'block';
  } else {
    karatRow.style.display = 'none';
    weightRow.style.display = 'none';
  }
  notesRow.style.display = 'block';
  updateQuoteMessage();
}

function selectKarat(btn) {
  document.querySelectorAll('.qkarat-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  qKarat = btn.dataset.val;
  updateQuoteMessage();
}

function formatPhone(el) {
  // Strip everything except digits
  let digits = el.value.replace(/\D/g, '').slice(0, 10);
  let formatted = digits;
  if (digits.length > 6) {
    formatted = digits.slice(0,3) + '-' + digits.slice(3,6) + '-' + digits.slice(6);
  } else if (digits.length > 3) {
    formatted = digits.slice(0,3) + '-' + digits.slice(3);
  }
  el.value = formatted;
}

function updateQuoteMessage() {
  const fname = (document.getElementById('q-fname').value || '').trim();
  const lname = (document.getElementById('q-lname').value || '').trim();
  const phone = (document.getElementById('q-phone').value || '').trim();
  const email = (document.getElementById('q-email').value || '').trim();
  const weightEl = document.getElementById('q-weight');
  const unitEl = document.getElementById('q-weight-unit');
  const notesEl = document.getElementById('q-notes');
  const weight = weightEl ? weightEl.value : '';
  const unit = unitEl ? unitEl.value : 'grams';
  const notes = notesEl ? notesEl.value.trim() : '';

  const previewWrap = document.getElementById('quote-preview-wrap');
  const preview = document.getElementById('quote-preview');
  if (!fname && !lname && !qMetal) { previewWrap.style.display = 'none'; return; }
  previewWrap.style.display = 'block';

  const name = [fname, lname].filter(Boolean).join(' ') || '[Your Name]';
  let msg = 'Hello Gold 4UNMe Team,\n\n';
  msg += 'My name is ' + name + ' and I\'d like to get a free quote.\n\n';
  if (qMetal) {
    msg += '📦 Item: ' + qMetal;
    if (qKarat) msg += ' — ' + qKarat;
    msg += '\n';
    if (weight && WEIGHT_METALS.includes(qMetal)) msg += '⚖️ Weight: approximately ' + weight + ' ' + unit + '\n';
    if (notes) msg += '📝 Notes: ' + notes + '\n';
  }
  msg += '\n';
  if (phone) msg += '📞 Phone: ' + phone + '\n';
  if (email) msg += '✉️ Email: ' + email + '\n';
  msg += '\nThank you!';
  preview.textContent = msg;
}

function sendQuoteSMS() {
  const txt = (document.getElementById('quote-preview') || {}).textContent || '';
  if (!txt.trim()) { alert('Please fill in your info and select a metal first.'); return; }
  window.location.href = 'sms:+14085695708&body=' + encodeURIComponent(txt);
}

function sendQuoteEmail() {
  const txt = (document.getElementById('quote-preview') || {}).textContent || '';
  if (!txt.trim()) { alert('Please fill in your info and select a metal first.'); return; }
  window.location.href = 'mailto:gold4unme408@gmail.com?subject=' + encodeURIComponent('Free Quote Request — Gold 4UNMe') + '&body=' + encodeURIComponent(txt);
}

// ── QUOTE FORM ──
function submitQuote(){
  const fn=document.getElementById('q-fname').value.trim();
  const ph=document.getElementById('q-phone').value.trim();
  const cat=document.getElementById('q-category').value;
  const desc=document.getElementById('q-desc').value.trim();
  if(!fn||!ph||!cat||!desc){alert('Please fill in your name, phone, item category, and description.');return;}
  const ref='G4UM-'+String(Math.floor(Math.random()*90000)+10000);
  document.getElementById('success-ref').textContent='REF #'+ref;
  document.getElementById('form-body').style.display='none';
  document.getElementById('form-success').classList.add('show');
}

// ── SCROLL REVEAL ──
try {
  document.documentElement.classList.add('js-ready');
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('visible'); });
  },{threshold:0.08, rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('[data-reveal]').forEach(el=>io.observe(el));
} catch(e){}

} catch(outerErr){ console.warn('Init error:', outerErr); }

// ── SMOOTH SCROLL ──

// ── LANGUAGE TOGGLE ──
const TRANSLATIONS = {
  en: {
    // Nav
    'nav_whatwebuy': 'What We Buy',
    'nav_education': 'Education',
    'nav_howtosell': 'How to Sell',
    'nav_getaquote': 'Get a Quote',
    'nav_callus': 'Call Us',
    'nav_cta': 'Get a Quote',
    'logo_tagline': 'Gold For You And Me · San Jose & Bay Area, CA',

    // Ticker
    'ticker_live': 'LIVE',

    // Hero
    'hero_eyebrow': "Bay Area's Premier Metals Buyer",
    'hero_title1': 'We Buy Everything',
    'hero_title2': 'Precious.',
    'hero_subtitle': 'Gold · Silver · Platinum · Diamonds · Watches · Coins · More',
    'hero_body': 'Walk into our San Jose showroom for a free XRF-verified assessment — or submit online. We show you exactly how we calculate every offer. No pressure, no guesswork, no waiting.',
    'hero_btn1': 'Get a Free Quote',
    'hero_btn2': 'What We Buy',
    'hero_trust1_val': '10+',
    'hero_trust1_lbl': 'Years in Business',
    'hero_trust2_val': 'XRF',
    'hero_trust2_lbl': 'Verified Testing',
    'hero_trust3_val': '$2M+',
    'hero_trust3_lbl': 'Paid to Sellers',
    'hero_trust4_val': '$0',
    'hero_trust4_lbl': 'Testing Fee',
    'price_card_title': 'Live Spot Prices',

    // Trust strip
    'trust1_strong': 'Fully Licensed',
    'trust1_span': 'CA Precious Metals Dealer',
    'trust2_strong': 'Certified Scales',
    'trust2_span': 'NIST-traceable calibration',
    'trust3_strong': 'XRF Analysis',
    'trust3_span': 'Non-destructive metal testing',
    'trust4_strong': 'No Pressure',
    'trust4_span': 'Decline any offer, no fee',
    'trust5_strong': 'Instant Payment',
    'trust5_span': 'Cash or same-day wire',
    'trust6_strong': '(408) 569-5708',
    'trust6_span': 'Mon–Sat · 11am – 6pm',

    // What We Buy section
    'buy_eyebrow': 'Everything Precious',
    'buy_title': 'What We',
    'buy_title_em': 'Buy',
    'buy_sub': "Click any category to see the full list of items we accept. We buy more than most — if it has precious metal content, we want to see it.",
    'buy_cta': 'Request a Quote →',

    // Categories
    'cat_gold_name': 'Gold',
    'cat_gold_sub': 'All Karats · All Conditions',
    'cat_gold_desc': '10K–24K jewelry, coins, bars, dental gold, and industrial. Best payouts in the Bay Area.',
    'cat_silver_name': 'Silver',
    'cat_silver_sub': 'Sterling · Coins · Industrial',
    'cat_silver_desc': 'Sterling flatware, jewelry, bullion coins and bars, 90% junk silver, industrial silver.',
    'cat_platinum_name': 'Platinum & PGMs',
    'cat_platinum_sub': 'Palladium · Rhodium · Iridium',
    'cat_platinum_desc': 'Platinum jewelry, palladium, rhodium, iridium and all PGM scrap. Industrial and dental PGM recovery.',
    'cat_gems_name': 'Gems & Diamonds',
    'cat_gems_sub': 'Certified & Uncertified',
    'cat_gems_desc': 'GIA-certified and uncertified diamonds, rubies, sapphires, emeralds, and estate stones.',
    'cat_watches_name': 'Luxury Watches',
    'cat_watches_sub': 'Rolex · Patek · Cartier & More',
    'cat_watches_desc': 'Top prestige brands — working or not, with or without papers. Market-rate offers always.',
    'cat_escrap_name': 'E-Scrap & CPU Metals',
    'cat_escrap_sub': 'CPUs · PCBs · Connectors',
    'cat_escrap_desc': 'Gold-bearing CPUs, circuit boards, gold fingers, RAM, and palladium MLCCs. Bulk welcome.',
    'cat_industrial_name': 'Industrial Recovery',
    'cat_industrial_sub': 'Dental · Lab · Manufacturing',
    'cat_industrial_desc': 'Dental alloy scrap, lab crucibles, catalysts, thermocouples, and all manufacturing PM waste.',
    'cat_other_name': 'Estate & Other',
    'cat_other_sub': 'Collections · Antiques · Mixed Lots',
    'cat_other_desc': 'Full estate collections, antique jewelry, designer signed pieces, and mixed precious metal lots.',
    'cat_arrow': 'View Details →',

    // Education section
    'edu_eyebrow': 'Seller Education',
    'edu_title': "Know Your Metal's",
    'edu_title_em': 'Value',
    'edu_sub': "Gold has been money for 6,000 years. Silver built empires. Knowing what you have — and why it has value — puts you in control.",
    'tab_goldkarats': 'Gold Karat Guide',
    'tab_silvergrades': 'Silver Grades',
    'tab_platinum': 'Platinum & PGMs',
    'tab_goldcoins': 'Gold Coins',
    'tab_silvercoins': 'Silver Coins',
    'tab_rounds': 'Gold & Silver Rounds',
    'tab_hallmarks': 'Hallmarks & Stamps',
    'tab_goldfilled': 'Gold-Filled vs Plated',
    'tab_goldhistory': 'History of Gold',
    'tab_silverhistory': 'History of Silver',
    'group_by_metal': 'By Metal',
    'group_coins_rounds': 'Coins & Rounds',
    'group_identify': 'Identify Your Item',
    'group_history': 'History',

    // Quote section
    'quote_eyebrow': 'Free & No Obligation',
    'quote_title': 'Get Your Free',
    'quote_title_em': 'Quote',
    'quote_sub': 'Submit online or walk in any time. No appointment needed. We respond to online requests within 2 business hours.',
    'step1_title': 'Describe Your Items',
    'step1_body': 'Tell us what you have — type, karat, approximate weight, and condition. A photo helps but isn\'t required.',
    'step2_title': 'Free XRF Testing',
    'step2_body': 'We verify metal content instantly with our spectrometer. Non-destructive. Takes seconds. You see the readout in real time.',
    'step3_title': 'Transparent Offer',
    'step3_body': 'We calculate your offer based on live spot prices and actual metal content. We show every step of our math.',
    'step4_title': 'Get Paid Same Day',
    'step4_body': 'Accept and receive cash, check, or bank wire on the spot. No holds. No waiting. You leave with your payment.',
    'chip_free': 'Free Testing',
    'chip_noob': 'No Obligation',
    'chip_instant': 'Instant Payment',
    'chip_licensed': 'Fully Licensed',
    'chip_math': 'We Show Our Math',
    'chip_nofees': 'No Hidden Fees',
    'form_title': 'Request a Free Quote',
    'form_sub': 'Online Form · Response Within 2 Hours',
    'form_lbl_firstname': 'First Name',
    'form_lbl_lastname': 'Last Name',
    'form_lbl_phone': 'Your Phone Number',
    'form_lbl_email': 'Your Email Address',
    'form_lbl_weight': 'Weight Amount',
    'form_lbl_unit': 'Weight Unit',
    'form_lbl_category': 'Item Category',
    'form_lbl_desc': 'Item Description',
    'form_lbl_contact': 'Preferred Contact',
    'form_btn': 'Submit Quote Request',
    'form_disclaim': 'No obligation. We never share your information. Testing is always free.',
    'form_ph_fname': 'First name',
    'form_ph_lname': 'Last name',
    'form_ph_phone': '(408) 569-5708',
    'form_ph_email': 'you@email.com',
    'form_ph_desc': "E.g.: '14K gold ring approx. 5g, small diamond'",
    'form_opt_default': '— Select a category —',
    'form_opt_phone': 'Phone Call',
    'form_opt_text': 'Text Message',
    'form_opt_email': 'Email',
    'form_opt_walkin': "I'll Walk In — No Callback Needed",

    // How to Sell
    'sell_eyebrow': '3 Ways to Sell',
    'sell_title': 'You Come to Us — or',
    'sell_title_em': 'We Come to You',
    'sell_sub': 'No matter how you prefer to do business, we make it easy. Choose the option that works best for you.',
    'sell1_badge': 'Most Popular',
    'sell1_title': 'Visit Our Store',
    'sell1_desc': 'Walk into our San Jose showroom any time during business hours. No appointment needed. Get an instant free assessment with our XRF spectrometer and leave with payment in hand.',
    'sell1_cta': 'Walk Ins Always Welcome →',
    'sell2_title': 'We Come to You',
    'sell2_desc': "We travel directly to your home, office, or preferred location in the Bay Area. Perfect for large collections, estate lots, or anyone who prefers privacy and convenience.",
    'sell2_cta': 'Call or Text to Schedule →',
    'sell3_title': 'Public Meet-Up',
    'sell3_desc': "Prefer a neutral location? We'll meet you at a public spot — a coffee shop, bank lobby, or police station parking lot.",
    'sell3_cta': 'Call Or Text To Schedule →',

    // Why Us
    'why_eyebrow': 'Why Gold 4UNMe',
    'why_title': "The Bay Area's",
    'why_title_em': 'Trusted',
    'why_title2': 'Buyer',
    'why_sub': 'Over a decade of fair, transparent precious metals buying in San Jose. Our repeat business speaks for itself.',
    'why1_title': 'Best Prices, Period',
    'why1_body': 'We monitor live spot prices and pay a higher percentage than most local buyers. Our business depends on repeat customers and referrals — not one-time lowball offers.',
    'why2_title': 'XRF Technology',
    'why2_body': 'Our X-ray fluorescence spectrometer provides instant, accurate, non-destructive analysis. You see the readout in real time. No guessing, no acid damage to your jewelry.',
    'why3_title': 'Licensed & Insured',
    'why3_body': 'Fully licensed as a precious metals dealer in California. All transactions documented and secure. Your items are covered by our commercial insurance from the moment you hand them over.',
    'why4_title': 'We Buy Everything',
    'why4_body': 'Most buyers cherry-pick only easy items. We buy broken jewelry, dental gold, e-scrap, estate collections — anything with precious metal content.',

    // Footer
    'footer_about': '"Gold For You And Me" — San Jose\'s trusted precious metals buyer since 2010. We buy gold, silver, platinum, gems, luxury watches, e-scrap, and industrial metals at the best prices in the Bay Area.',
    'footer_hours_title': 'Store Hours',
    'footer_hours': 'Monday – Saturday: 11:00am – 6:00pm\nSunday: Appointments Only',
    'footer_col_buy': 'What We Buy',
    'footer_col_learn': 'Learn',
    'footer_col_paid': 'Get Paid Today',
    'footer_col_paid_body': 'Walk in any time or submit an online quote. No appointment needed for most items.',
    'footer_btn_quote': 'Request a Quote',
    'footer_copy': '© 2026 Gold 4UNMe · San Jose, CA · All Rights Reserved · gold4unme.co',
    // Sell card list items
    'sell1_li1': '642 Blossom Hill Rd, San Jose CA',
    'sell1_li2': 'Mon–Sat · 11:00am – 6:00pm · Sun by Appt',
    'sell1_li3': 'XRF testing on-site — instant results',
    'sell1_li4': 'No appointment needed',
    'sell1_li5': 'Walk out with cash in hand',
    'sell2_li1': 'San Jose & surrounding Bay Area',
    'sell2_li2': 'Scheduled at your convenience',
    'sell2_li3': 'We bring our testing equipment',
    'sell2_li4': 'Pay on the spot — same visit',
    'sell2_li5': 'Discreet, professional, insured',
    'sell3_li1': 'Bank lobbies & public spaces',
    'sell3_li2': 'Police station parking lots welcome',
    'sell3_li3': 'Usually 15–30 minutes total',
    'sell3_li4': 'No appointment needed for small lots',
    'sell3_li5': 'Text us to confirm a time & place',
    'sell_pay_label': 'We pay with:',
    'sell_hours_label': '⏰ Available Hours for Home Visits',
    // FAQ section
    'faq_eyebrow': 'Common Questions',
    'faq_title': 'Frequently Asked',
    'faq_title_em': 'Questions',
    'faq_sub': 'Everything you want to know before you walk in.',
  },

  es: {
    // Nav
    'nav_whatwebuy': 'Qué Compramos',
    'nav_education': 'Educación',
    'nav_howtosell': 'Cómo Vender',
    'nav_getaquote': 'Cotización Gratis',
    'nav_callus': 'Llámenos',
    'nav_cta': 'Cotización Gratis',
    'logo_tagline': 'Oro Para Ti Y Para Mí · San José & Área de la Bahía, CA',

    // Ticker
    'ticker_live': 'EN VIVO',

    // Hero
    'hero_eyebrow': 'El Comprador Principal de Metales del Área de la Bahía',
    'hero_title1': 'Compramos Todo lo que es',
    'hero_title2': 'Precioso.',
    'hero_subtitle': 'Oro · Plata · Platino · Diamantes · Relojes · Monedas · Y Más',
    'hero_body': 'Visítenos en nuestra tienda de San José para una evaluación gratuita verificada con XRF — o envíe en línea. Le mostramos exactamente cómo calculamos cada oferta. Sin presión, sin adivinar, sin esperar.',
    'hero_btn1': 'Obtener Cotización Gratis',
    'hero_btn2': 'Qué Compramos',
    'hero_trust1_val': '10+',
    'hero_trust1_lbl': 'Años en Negocio',
    'hero_trust2_val': 'XRF',
    'hero_trust2_lbl': 'Prueba Verificada',
    'hero_trust3_val': '$2M+',
    'hero_trust3_lbl': 'Pagado a Vendedores',
    'hero_trust4_val': '$0',
    'hero_trust4_lbl': 'Costo de Prueba',
    'price_card_title': 'Precios al Contado en Vivo',

    // Trust strip
    'trust1_strong': 'Licencia Completa',
    'trust1_span': 'Distribuidor de Metales Preciosos CA',
    'trust2_strong': 'Balanzas Certificadas',
    'trust2_span': 'Calibración trazable NIST',
    'trust3_strong': 'Análisis XRF',
    'trust3_span': 'Prueba de metales no destructiva',
    'trust4_strong': 'Sin Presión',
    'trust4_span': 'Rechace cualquier oferta, sin costo',
    'trust5_strong': 'Pago Inmediato',
    'trust5_span': 'Efectivo o transferencia el mismo día',
    'trust6_strong': '(408) 569-5708',
    'trust6_span': 'Lun–Sáb · 11am – 6pm',

    // What We Buy
    'buy_eyebrow': 'Todo lo Precioso',
    'buy_title': 'Qué',
    'buy_title_em': 'Compramos',
    'buy_sub': 'Haga clic en cualquier categoría para ver la lista completa de artículos que aceptamos. Compramos más que la mayoría — si tiene contenido de metal precioso, queremos verlo.',
    'buy_cta': 'Solicitar Cotización →',

    // Categories
    'cat_gold_name': 'Oro',
    'cat_gold_sub': 'Todos los Quilates · Todas las Condiciones',
    'cat_gold_desc': 'Joyas 10K–24K, monedas, barras, oro dental e industrial. Los mejores pagos en el Área de la Bahía.',
    'cat_silver_name': 'Plata',
    'cat_silver_sub': 'Sterling · Monedas · Industrial',
    'cat_silver_desc': 'Cubiertos de plata sterling, joyas, monedas y barras de lingotes, plata al 90%, plata industrial.',
    'cat_platinum_name': 'Platino y PGMs',
    'cat_platinum_sub': 'Paladio · Rodio · Iridio',
    'cat_platinum_desc': 'Joyas de platino, paladio, rodio, iridio y toda chatarra PGM. Recuperación industrial y dental.',
    'cat_gems_name': 'Gemas y Diamantes',
    'cat_gems_sub': 'Certificados y Sin Certificar',
    'cat_gems_desc': 'Diamantes certificados GIA y sin certificar, rubíes, zafiros, esmeraldas y piedras de herencia.',
    'cat_watches_name': 'Relojes de Lujo',
    'cat_watches_sub': 'Rolex · Patek · Cartier y Más',
    'cat_watches_desc': 'Las mejores marcas de prestigio — funcionen o no, con o sin papeles. Siempre ofrecemos precios de mercado.',
    'cat_escrap_name': 'Chatarra Electrónica y CPUs',
    'cat_escrap_sub': 'CPUs · PCBs · Conectores',
    'cat_escrap_desc': 'CPUs con oro, placas de circuito, conectores dorados, RAM y MLCCs de paladio. Se acepta volumen.',
    'cat_industrial_name': 'Recuperación Industrial',
    'cat_industrial_sub': 'Dental · Laboratorio · Manufactura',
    'cat_industrial_desc': 'Chatarra de aleaciones dentales, crisoles de laboratorio, catalizadores, termopares y desechos de manufactura.',
    'cat_other_name': 'Herencia y Otros',
    'cat_other_sub': 'Colecciones · Antigüedades · Lotes Mixtos',
    'cat_other_desc': 'Colecciones completas de herencia, joyas antiguas, piezas de diseñador y lotes mixtos de metales preciosos.',
    'cat_arrow': 'Ver Detalles →',

    // Education
    'edu_eyebrow': 'Educación para el Vendedor',
    'edu_title': 'Conozca el',
    'edu_title_em': 'Valor de su Metal',
    'edu_sub': 'El oro ha sido dinero por 6,000 años. La plata construyó imperios. Saber lo que tiene — y por qué tiene valor — le pone en control.',
    'tab_goldkarats': 'Guía de Quilates de Oro',
    'tab_silvergrades': 'Grados de Plata',
    'tab_goldcoins': 'Monedas de Oro',
    'tab_silvercoins': 'Monedas de Plata',
    'tab_goldkarats': 'Guía de Quilates de Oro',
    'tab_silvergrades': 'Grados de Plata',
    'tab_platinum': 'Platino y PGMs',
    'tab_goldcoins': 'Monedas de Oro',
    'tab_silvercoins': 'Monedas de Plata',
    'tab_rounds': 'Rondas de Oro y Plata',
    'tab_hallmarks': 'Sellos y Marcas',
    'tab_goldfilled': 'Oro Laminado vs Chapado',
    'tab_goldhistory': 'Historia del Oro',
    'tab_silverhistory': 'Historia de la Plata',
    'group_by_metal': 'Por Metal',
    'group_coins_rounds': 'Monedas y Rondas',
    'group_identify': 'Identifica tu Artículo',
    'group_history': 'Historia',

    // Quote section
    'quote_eyebrow': 'Gratis y Sin Compromiso',
    'quote_title': 'Obtenga su',
    'quote_title_em': 'Cotización Gratis',
    'quote_sub': 'Envíe en línea o visítenos en cualquier momento. No necesita cita. Respondemos a solicitudes en línea en 2 horas hábiles.',
    'step1_title': 'Describa sus Artículos',
    'step1_body': 'Díganos qué tiene — tipo, quilate, peso aproximado y condición. Una foto ayuda pero no es obligatoria.',
    'step2_title': 'Prueba XRF Gratuita',
    'step2_body': 'Verificamos el contenido de metal al instante con nuestro espectrómetro. No destructivo. Toma segundos. Usted ve el resultado en tiempo real.',
    'step3_title': 'Oferta Transparente',
    'step3_body': 'Calculamos su oferta basándonos en los precios al contado en vivo y el contenido real de metal. Mostramos cada paso de nuestro cálculo.',
    'step4_title': 'Reciba su Pago el Mismo Día',
    'step4_body': 'Acepte y reciba efectivo, cheque o transferencia bancaria en el momento. Sin esperas. Se va con su pago.',
    'chip_free': 'Prueba Gratis',
    'chip_noob': 'Sin Compromiso',
    'chip_instant': 'Pago Inmediato',
    'chip_licensed': 'Completamente Licenciado',
    'chip_math': 'Mostramos Nuestros Cálculos',
    'chip_nofees': 'Sin Cargos Ocultos',
    'form_title': 'Solicitar Cotización Gratuita',
    'form_sub': 'Formulario en Línea · Respuesta en 2 Horas',
    'form_lbl_firstname': 'Nombre',
    'form_lbl_lastname': 'Apellido',
    'form_lbl_phone': 'Tu Número de Teléfono',
    'form_lbl_email': 'Tu Correo Electrónico',
    'form_lbl_weight': 'Cantidad de Peso',
    'form_lbl_unit': 'Unidad de Peso',
    'form_lbl_category': 'Categoría del Artículo',
    'form_lbl_desc': 'Descripción del Artículo',
    'form_lbl_contact': 'Forma de Contacto Preferida',
    'form_btn': 'Enviar Solicitud de Cotización',
    'form_disclaim': 'Sin compromiso. Nunca compartimos su información. La prueba siempre es gratuita.',
    'form_ph_fname': 'Nombre',
    'form_ph_lname': 'Apellido',
    'form_ph_phone': '(408) 569-5708',
    'form_ph_email': 'usted@correo.com',
    'form_ph_desc': "Ej.: 'Anillo de oro 14K aprox. 5g, diamante pequeño'",
    'form_opt_default': '— Seleccione una categoría —',
    'form_opt_phone': 'Llamada Telefónica',
    'form_opt_text': 'Mensaje de Texto',
    'form_opt_email': 'Correo Electrónico',
    'form_opt_walkin': 'Iré en Persona — Sin Necesidad de Devolución de Llamada',

    // How to Sell
    'sell_eyebrow': '3 Formas de Vender',
    'sell_title': 'Usted Viene a Nosotros — o',
    'sell_title_em': 'Nosotros Vamos a Usted',
    'sell_sub': 'No importa cómo prefiera hacer negocios, lo hacemos fácil. Elija la opción que mejor le convenga.',
    'sell1_badge': 'Más Popular',
    'sell1_title': 'Visítenos en la Tienda',
    'sell1_desc': 'Entre a nuestra tienda de San José en cualquier momento durante el horario comercial. Sin cita. Obtenga una evaluación gratuita con nuestro espectrómetro XRF y salga con el pago en mano.',
    'sell1_cta': 'Entra · Te Evaluamos · Te Pagamos →',
    'sell2_title': 'Nosotros Vamos a Usted',
    'sell2_desc': 'Viajamos directamente a su hogar, oficina o lugar preferido en el Área de la Bahía. Perfecto para colecciones grandes, lotes de herencia o cualquiera que prefiera privacidad y comodidad.',
    'sell2_cta': 'Llame o Escriba para Programar →',
    'sell3_title': 'Reunión en Lugar Público',
    'sell3_desc': '¿Prefiere un lugar neutral? Nos reunimos en un lugar público — una cafetería, vestíbulo de banco o estacionamiento de la estación de policía.',
    'sell3_cta': 'Llame o Escriba para Programar →',

    // Why Us
    'why_eyebrow': 'Por Qué Gold 4UNMe',
    'why_title': 'El Comprador',
    'why_title_em': 'de Confianza',
    'why_title2': 'del Área de la Bahía',
    'why_sub': 'Más de una década de compra justa y transparente de metales preciosos en San José. Nuestros clientes habituales hablan por sí solos.',
    'why1_title': 'Los Mejores Precios, Sin Duda',
    'why1_body': 'Monitoreamos los precios al contado en vivo y pagamos un porcentaje más alto que la mayoría de los compradores locales. Nuestro negocio depende de clientes habituales y referencias — no de ofertas únicas bajas.',
    'why2_title': 'Tecnología XRF',
    'why2_body': 'Nuestro espectrómetro de fluorescencia de rayos X proporciona análisis instantáneo, preciso y no destructivo. Usted ve el resultado en tiempo real. Sin adivinanzas, sin daño con ácido a sus joyas.',
    'why3_title': 'Licenciado y Asegurado',
    'why3_body': 'Completamente licenciado como distribuidor de metales preciosos en California. Todas las transacciones documentadas y seguras. Sus artículos están cubiertos por nuestro seguro comercial desde el momento en que los entrega.',
    'why4_title': 'Compramos Todo',
    'why4_body': 'La mayoría de los compradores solo eligen artículos fáciles. Nosotros compramos joyas rotas, oro dental, chatarra electrónica, colecciones de herencia — cualquier cosa con contenido de metal precioso.',

    // Footer
    'footer_about': '"Oro Para Ti Y Para Mí" — El comprador de metales preciosos de confianza de San José desde 2010. Compramos oro, plata, platino, gemas, relojes de lujo, chatarra electrónica y metales industriales a los mejores precios del Área de la Bahía.',
    'footer_hours_title': 'Horario de la Tienda',
    'footer_hours': 'Lunes – Sábado: 11:00am – 6:00pm\nDomingo: Solo con Cita',
    'footer_col_buy': 'Qué Compramos',
    'footer_col_learn': 'Aprenda',
    'footer_col_paid': 'Reciba su Pago Hoy',
    'footer_col_paid_body': 'Visítenos en cualquier momento o envíe una cotización en línea. Sin cita para la mayoría de los artículos.',
    'footer_btn_quote': 'Solicitar Cotización',
    'footer_copy': '© 2026 Gold 4UNMe · San José, CA · Todos los Derechos Reservados · gold4unme.co',
    // Sell card list items
    'sell1_li1': '642 Blossom Hill Rd, San José CA',
    'sell1_li2': 'Lun–Sáb · 11:00am – 6:00pm · Dom con Cita',
    'sell1_li3': 'Prueba XRF en sitio — resultados instantáneos',
    'sell1_li4': 'Sin cita necesaria',
    'sell1_li5': 'Salga con efectivo en mano',
    'sell2_li1': 'San José y el Área de la Bahía',
    'sell2_li2': 'Programado a su conveniencia',
    'sell2_li3': 'Llevamos nuestro equipo de prueba',
    'sell2_li4': 'Pago en el momento — misma visita',
    'sell2_li5': 'Discreto, profesional, asegurado',
    'sell3_li1': 'Vestíbulos de banco y espacios públicos',
    'sell3_li2': 'Estacionamientos de estaciones de policía',
    'sell3_li3': 'Generalmente 15–30 minutos en total',
    'sell3_li4': 'Sin cita para lotes pequeños',
    'sell3_li5': 'Escríbanos para confirmar hora y lugar',
    'sell_pay_label': 'Pagamos con:',
    'sell_hours_label': '⏰ Horario Disponible para Visitas a Domicilio',
    // FAQ section
    'faq_eyebrow': 'Preguntas Frecuentes',
    'faq_title': 'Preguntas',
    'faq_title_em': 'Frecuentes',
    'faq_sub': 'Todo lo que quiere saber antes de visitarnos.',
  }
};

// Map of translation keys to DOM selectors/targets
const I18N_MAP = [
  // Nav links
  { key: 'nav_whatwebuy', sel: 'a[href="#what-we-buy"].nav-link:not(.nav-cta)', type: 'text' },
  { key: 'nav_education', sel: 'a[href="#education"].nav-link', type: 'text' },
  { key: 'nav_howtosell', sel: 'a[href="#how-to-sell"].nav-link', type: 'text' },
  { key: 'nav_callus', sel: 'a[href="tel:+14085695708"].nav-link', type: 'text' },
  { key: 'nav_cta', sel: '.nav-cta span', type: 'text' },
  { key: 'logo_tagline', sel: '.logo-tagline', type: 'text', all: true },

  // Hero
  { key: 'hero_eyebrow', sel: '.hero-eyebrow .eyebrow', type: 'text' },
  { key: 'hero_title1', sel: '.hero-title', type: 'firstText' },
  { key: 'hero_title2', sel: '.hero-title strong', type: 'text' },
  { key: 'hero_subtitle', sel: '.hero-subtitle', type: 'text' },
  { key: 'hero_body', sel: '.hero-body', type: 'text' },
  { key: 'hero_btn1', sel: '.hero-btns .btn-gold span:first-child', type: 'text' },
  { key: 'hero_btn2', sel: '.hero-btns .btn-ghost', type: 'text' },
  { key: 'hero_trust1_lbl', sel: '.htrust:nth-child(1) .htrust-lbl', type: 'text' },
  { key: 'hero_trust2_lbl', sel: '.htrust:nth-child(2) .htrust-lbl', type: 'text' },
  { key: 'hero_trust3_lbl', sel: '.htrust:nth-child(3) .htrust-lbl', type: 'text' },
  { key: 'hero_trust4_lbl', sel: '.htrust:nth-child(4) .htrust-lbl', type: 'text' },
  { key: 'price_card_title', sel: '.price-card-title', type: 'lastText' },

  // Trust strip
  { key: 'trust1_strong', sel: '.trust-strip .ti:nth-child(1) .ti-text strong', type: 'text' },
  { key: 'trust1_span', sel: '.trust-strip .ti:nth-child(1) .ti-text span', type: 'text' },
  { key: 'trust2_strong', sel: '.trust-strip .ti:nth-child(3) .ti-text strong', type: 'text' },
  { key: 'trust2_span', sel: '.trust-strip .ti:nth-child(3) .ti-text span', type: 'text' },
  { key: 'trust3_strong', sel: '.trust-strip .ti:nth-child(5) .ti-text strong', type: 'text' },
  { key: 'trust3_span', sel: '.trust-strip .ti:nth-child(5) .ti-text span', type: 'text' },
  { key: 'trust4_strong', sel: '.trust-strip .ti:nth-child(7) .ti-text strong', type: 'text' },
  { key: 'trust4_span', sel: '.trust-strip .ti:nth-child(7) .ti-text span', type: 'text' },
  { key: 'trust5_strong', sel: '.trust-strip .ti:nth-child(9) .ti-text strong', type: 'text' },
  { key: 'trust5_span', sel: '.trust-strip .ti:nth-child(9) .ti-text span', type: 'text' },
  { key: 'trust6_strong', sel: '.trust-strip .ti:nth-child(11) .ti-text strong', type: 'text' },
  { key: 'trust6_span', sel: '.trust-strip .ti:nth-child(11) .ti-text span', type: 'text' },

  // What We Buy
  { key: 'buy_eyebrow', sel: '#what-we-buy .eyebrow', type: 'text' },
  { key: 'buy_title', sel: '#what-we-buy .s-title', type: 'firstText' },
  { key: 'buy_title_em', sel: '#what-we-buy .s-title em', type: 'text' },
  { key: 'buy_sub', sel: '#what-we-buy .s-sub', type: 'text' },
  { key: 'buy_cta', sel: '#what-we-buy .btn-ghost[data-reveal]', type: 'text' },

  // Education
  { key: 'edu_eyebrow', sel: '#education .eyebrow', type: 'text' },
  { key: 'edu_title', sel: '#education .s-title', type: 'firstText' },
  { key: 'edu_title_em', sel: '#education .s-title em', type: 'text' },
  { key: 'edu_sub', sel: '#education .s-sub', type: 'text' },
  { key: 'tab_goldkarats',  sel: '[data-tab-i18n="tab_goldkarats"]',  type: 'text' },
  { key: 'tab_silvergrades',sel: '[data-tab-i18n="tab_silvergrades"]',type: 'text' },
  { key: 'tab_platinum',    sel: '[data-tab-i18n="tab_platinum"]',    type: 'text' },
  { key: 'tab_goldcoins',   sel: '[data-tab-i18n="tab_goldcoins"]',   type: 'text' },
  { key: 'tab_silvercoins', sel: '[data-tab-i18n="tab_silvercoins"]', type: 'text' },
  { key: 'tab_rounds',      sel: '[data-tab-i18n="tab_rounds"]',      type: 'text' },
  { key: 'tab_hallmarks',   sel: '[data-tab-i18n="tab_hallmarks"]',   type: 'text' },
  { key: 'tab_goldfilled',  sel: '[data-tab-i18n="tab_goldfilled"]',  type: 'text' },
  { key: 'tab_goldhistory', sel: '[data-tab-i18n="tab_goldhistory"]', type: 'text' },
  { key: 'tab_silverhistory',sel:'[data-tab-i18n="tab_silverhistory"]',type:'text' },
  { key: 'group_by_metal',  sel: '[data-i18n-group="by_metal"]',      type: 'text' },
  { key: 'group_coins_rounds',sel:'[data-i18n-group="coins_rounds"]', type: 'text' },
  { key: 'group_identify',  sel: '[data-i18n-group="identify"]',      type: 'text' },
  { key: 'group_history',   sel: '[data-i18n-group="history"]',       type: 'text' },

  // Quote
  { key: 'quote_eyebrow', sel: '#get-quote .eyebrow', type: 'text' },
  { key: 'quote_title', sel: '#get-quote .s-title', type: 'firstText' },
  { key: 'quote_title_em', sel: '#get-quote .s-title em', type: 'text' },
  { key: 'quote_sub', sel: '#get-quote .s-sub', type: 'text' },
  { key: 'step1_title', sel: '.proc-step:nth-child(1) .ps-text strong', type: 'text' },
  { key: 'step1_body', sel: '.proc-step:nth-child(1) .ps-text p', type: 'text' },
  { key: 'step2_title', sel: '.proc-step:nth-child(2) .ps-text strong', type: 'text' },
  { key: 'step2_body', sel: '.proc-step:nth-child(2) .ps-text p', type: 'text' },
  { key: 'step3_title', sel: '.proc-step:nth-child(3) .ps-text strong', type: 'text' },
  { key: 'step3_body', sel: '.proc-step:nth-child(3) .ps-text p', type: 'text' },
  { key: 'step4_title', sel: '.proc-step:nth-child(4) .ps-text strong', type: 'text' },
  { key: 'step4_body', sel: '.proc-step:nth-child(4) .ps-text p', type: 'text' },
  { key: 'form_title', sel: '.form-hd-title', type: 'text' },
  { key: 'form_sub', sel: '.form-hd-sub', type: 'text' },
  { key: 'form_btn', sel: '.fsub span:first-child', type: 'text' },
  { key: 'form_disclaim', sel: '.fdisclaim', type: 'text' },
  { key: 'form_ph_fname', sel: '#q-fname', type: 'placeholder' },
  { key: 'form_ph_lname', sel: '#q-lname', type: 'placeholder' },
  { key: 'form_ph_phone', sel: '#q-phone', type: 'placeholder' },
  { key: 'form_ph_email', sel: '#q-email', type: 'placeholder' },
  { key: 'form_ph_desc', sel: '#q-desc', type: 'placeholder' },

  // How to Sell
  { key: 'sell_eyebrow', sel: '#how-to-sell .eyebrow', type: 'text' },
  { key: 'sell_title', sel: '#how-to-sell .s-title', type: 'firstText' },
  { key: 'sell_title_em', sel: '#how-to-sell .s-title em', type: 'text' },
  { key: 'sell_sub', sel: '#how-to-sell .s-sub', type: 'text' },
  { key: 'sell1_title', sel: '.sell-card:nth-child(1) .sell-title', type: 'text' },
  { key: 'sell1_desc', sel: '.sell-card:nth-child(1) .sell-desc', type: 'text' },
  { key: 'sell2_title', sel: '.sell-card:nth-child(2) .sell-title', type: 'text' },
  { key: 'sell2_desc', sel: '.sell-card:nth-child(2) .sell-desc', type: 'text' },
  { key: 'sell3_title', sel: '.sell-card:nth-child(3) .sell-title', type: 'text' },
  { key: 'sell3_desc', sel: '.sell-card:nth-child(3) .sell-desc', type: 'text' },

  // Why Us
  { key: 'why_eyebrow', sel: '#why .eyebrow', type: 'text' },
  { key: 'why_sub', sel: '#why .s-sub', type: 'text' },
  { key: 'why1_title', sel: '.why-card:nth-child(1) .wc-title', type: 'text' },
  { key: 'why1_body', sel: '.why-card:nth-child(1) .wc-body', type: 'text' },
  { key: 'why2_title', sel: '.why-card:nth-child(2) .wc-title', type: 'text' },
  { key: 'why2_body', sel: '.why-card:nth-child(2) .wc-body', type: 'text' },
  { key: 'why3_title', sel: '.why-card:nth-child(3) .wc-title', type: 'text' },
  { key: 'why3_body', sel: '.why-card:nth-child(3) .wc-body', type: 'text' },
  { key: 'why4_title', sel: '.why-card:nth-child(4) .wc-title', type: 'text' },
  { key: 'why4_body', sel: '.why-card:nth-child(4) .wc-body', type: 'text' },

  // Footer
  { key: 'footer_about', sel: '.fl-about', type: 'text' },
  { key: 'footer_copy', sel: '.fcopy', type: 'text' },
  // FAQ section headers
  { key: 'faq_eyebrow', sel: '#faq .eyebrow', type: 'text' },
  { key: 'faq_title',   sel: '#faq .s-title', type: 'firstText' },
  { key: 'faq_title_em',sel: '#faq .s-title em', type: 'text' },
  { key: 'faq_sub',     sel: '#faq .s-sub', type: 'text' },
  // Sell pay labels
  { key: 'sell_pay_label', sel: '.sell-pay-label', type: 'text', all: true },
  { key: 'sell_hours_label', sel: '.shn-label', type: 'text' },
];

let currentLang = 'en';

function applyTranslation(lang) {
  const t = TRANSLATIONS[lang];
  if (!t) return;

  document.body.classList.add('lang-switching');

  setTimeout(function() {
    I18N_MAP.forEach(function(item) {
      try {
        if (item.all) {
          document.querySelectorAll(item.sel).forEach(function(el) {
            applyToEl(el, item.type, t[item.key]);
          });
        } else {
          const el = document.querySelector(item.sel);
          if (el) applyToEl(el, item.type, t[item.key]);
        }
      } catch(e) {}
    });

    // Form labels — target by input ID to avoid wrong labels on wrong fields
    try {
      var labelMap = {
        'q-fname': 'form_lbl_firstname',
        'q-lname': 'form_lbl_lastname',
        'q-phone': 'form_lbl_phone',
        'q-email': 'form_lbl_email',
        'q-weight': 'form_lbl_weight',
        'q-weight-unit': 'form_lbl_unit'
      };
      Object.keys(labelMap).forEach(function(inputId) {
        var input = document.getElementById(inputId);
        if (input) {
          var label = input.closest('.fg') ? input.closest('.fg').querySelector('.fl') : null;
          if (label && t[labelMap[inputId]]) label.textContent = t[labelMap[inputId]];
        }
      });
    } catch(e) {}

    // Select options
    try {
      const cat = document.getElementById('q-category');
      if (cat && cat.options[0]) cat.options[0].text = t['form_opt_default'] || cat.options[0].text;
      const contact = document.getElementById('q-contact');
      if (contact) {
        const opts = ['form_opt_phone','form_opt_text','form_opt_email','form_opt_walkin'];
        opts.forEach(function(k,i){ if(contact.options[i] && t[k]) contact.options[i].text = t[k]; });
      }
    } catch(e) {}

    // Category cards - name, sub, desc, arrow
    const catCards = document.querySelectorAll('.cat-card');
    const catKeys = ['gold','silver','platinum','gems','watches','escrap','industrial','other'];
    catCards.forEach(function(card, i) {
      const k = catKeys[i];
      if (!k) return;
      try {
        const name = card.querySelector('.cc-name');
        const sub = card.querySelector('.cc-sub');
        const desc = card.querySelector('.cc-desc');
        const arrow = card.querySelector('.cc-arrow');
        if (name && t['cat_'+k+'_name']) name.textContent = t['cat_'+k+'_name'];
        if (sub && t['cat_'+k+'_sub']) sub.textContent = t['cat_'+k+'_sub'];
        if (desc && t['cat_'+k+'_desc']) desc.textContent = t['cat_'+k+'_desc'];
        if (arrow && t['cat_arrow']) arrow.textContent = t['cat_arrow'];
        const imgLabel = card.querySelector('.cc-img-label');
        if (imgLabel && t['cat_'+k+'_name']) imgLabel.textContent = t['cat_'+k+'_name'];
      } catch(e) {}
    });

    // Sell card badges and CTAs
    try {
      const badge = document.querySelector('.sell-card-badge');
      if (badge && t['sell1_badge']) badge.textContent = t['sell1_badge'];
      const ctas = document.querySelectorAll('.sell-cta');
      if (ctas[0] && t['sell1_cta']) ctas[0].textContent = t['sell1_cta'];
      if (ctas[1] && t['sell2_cta']) ctas[1].textContent = t['sell2_cta'];
      if (ctas[2] && t['sell3_cta']) ctas[2].textContent = t['sell3_cta'];
    } catch(e) {}

    // Promise chips
    try {
      const chips = document.querySelectorAll('.pchip');
      const chipKeys = ['chip_free','chip_noob','chip_instant','chip_licensed','chip_math','chip_nofees'];
      chips.forEach(function(chip, i) {
        if (!chipKeys[i] || !t[chipKeys[i]]) return;
        const ck = chip.querySelector('.ck');
        chip.textContent = '';
        if (ck) chip.appendChild(ck);
        chip.appendChild(document.createTextNode(t[chipKeys[i]]));
      });
    } catch(e) {}

    // Footer columns titles
    try {
      const fcTitles = document.querySelectorAll('.fc-title');
      if (fcTitles[0] && t['footer_col_buy']) fcTitles[0].textContent = t['footer_col_buy'];
      if (fcTitles[1] && t['footer_col_learn']) fcTitles[1].textContent = t['footer_col_learn'];
      if (fcTitles[2] && t['footer_col_paid']) fcTitles[2].textContent = t['footer_col_paid'];
      const paidBody = document.querySelector('.footer-top > div:last-child > p');
      if (paidBody && t['footer_col_paid_body']) paidBody.textContent = t['footer_col_paid_body'];
      const quoteBtns = document.querySelectorAll('.footer-top .btn-gold span');
      if (quoteBtns[0] && t['footer_btn_quote']) quoteBtns[0].textContent = t['footer_btn_quote'];
    } catch(e) {}

    // Footer sell list items (hours label)
    try {
      const ftHours = document.querySelector('.fl-hours');
      if (ftHours && t['footer_hours_title'] && t['footer_hours']) {
        ftHours.innerHTML = '<strong>' + t['footer_hours_title'] + '</strong>' +
          t['footer_hours'].replace('\n','<br>');
      }
    } catch(e) {}

    // Why title (has em in middle)
    try {
      const whyTitle = document.querySelector('#why .s-title');
      if (whyTitle && t['why_title'] && t['why_title_em'] && t['why_title2']) {
        whyTitle.innerHTML = t['why_title'] + ' <em>' + t['why_title_em'] + '</em> ' + t['why_title2'];
      }
    } catch(e){}

    // Update toggle UI
    document.getElementById('lang-en').classList.toggle('active', lang === 'en');
    document.getElementById('lang-es').classList.toggle('active', lang === 'es');

    // Sell card list items
    try {
      const sellCards = document.querySelectorAll('.sell-card');
      [[0,'sell1'],[1,'sell2'],[2,'sell3']].forEach(function([i,prefix]) {
        const card = sellCards[i];
        if (!card) return;
        const items = card.querySelectorAll('.sell-list li');
        for (let n = 0; n < items.length; n++) {
          const key = prefix + '_li' + (n+1);
          if (t[key]) {
            const icon = items[n].querySelector('.sl-icon');
            items[n].textContent = '';
            if (icon) items[n].appendChild(icon);
            items[n].appendChild(document.createTextNode(t[key]));
          }
        }
      });
    } catch(e) {}

    // Update page lang attribute
    document.documentElement.lang = lang === 'es' ? 'es' : 'en';

    document.body.classList.remove('lang-switching');
  }, 150);
}

function applyToEl(el, type, val) {
  if (!val) return;
  if (type === 'text') { el.textContent = val; }
  else if (type === 'placeholder') { el.placeholder = val; }
  else if (type === 'firstText') {
    // Replace only the text nodes, preserve child elements
    const childNodes = Array.from(el.childNodes);
    const firstText = childNodes.find(n => n.nodeType === 3);
    if (firstText) firstText.textContent = val + ' ';
  }
  else if (type === 'lastText') {
    const childNodes = Array.from(el.childNodes);
    const texts = childNodes.filter(n => n.nodeType === 3);
    const last = texts[texts.length - 1];
    if (last) last.textContent = val;
    else el.prepend(document.createTextNode(val));
  }
}

function toggleLang() {
  currentLang = currentLang === 'en' ? 'es' : 'en';
  applyTranslation(currentLang);
  try { localStorage.setItem('g4um_lang', currentLang); } catch(e) {}
}

// Init: restore saved language
try {
  const saved = localStorage.getItem('g4um_lang');
  if (saved === 'es') { currentLang = 'es'; applyTranslation('es'); }
  else {
    document.getElementById('lang-en').classList.add('active');
  }
} catch(e) {
  document.getElementById('lang-en').classList.add('active');
}
try {
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const t=document.querySelector(a.getAttribute('href'));
      if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
    });
  });
} catch(e){}

// ── HERO CANVAS ANIMATION: Melting Gold into Bar ──
(function(){
try {
  const canvas = document.getElementById('hero-canvas');
  if(!canvas) return;
  const ctx = canvas.getContext('2d');

  function resize(){
    const p = canvas.parentElement;
    canvas.width  = p.offsetWidth  || window.innerWidth;
    canvas.height = p.offsetHeight || window.innerHeight;
  }
  window.addEventListener('load', function(){ resize(); window.addEventListener('resize', resize); startAnim(); });
  setTimeout(function(){ if(!canvas.width){ resize(); startAnim(); } }, 120);

  let started = false;
  function startAnim(){
    if(started) return; started = true;

    const W = ()=>canvas.width, H = ()=>canvas.height;

    // ─────────────────────────────────────────
    // STAGE MACHINE
    // Stages: 0=items_appear, 1=melt_down, 2=pool, 3=form_bar, 4=bar_glow, 5=reset
    // ─────────────────────────────────────────
    const CYCLE = 9000; // ms per full loop
    let cycleStart = 0;
    let stage = 0;
    let stageT = 0; // 0..1 progress within stage

    // Stage durations (fraction of CYCLE)
    const STAGES = [
      { id:'items',    dur:0.20 }, // items floating in
      { id:'heat',     dur:0.18 }, // heat shimmer on items
      { id:'melt',     dur:0.22 }, // items melt downward
      { id:'pool',     dur:0.12 }, // molten pool bubbling
      { id:'form',     dur:0.16 }, // pool rises into bar shape
      { id:'bar',      dur:0.12 }, // solid bar glows
    ];

    // ITEMS to show (jewelry → bar)
    const ITEMS = [
      { emoji:'💍', label:'Gold Ring',     x:0.28, y:0.35, scale:1.0 },
      { emoji:'📿', label:'Gold Chain',    x:0.42, y:0.28, scale:0.9 },
      { emoji:'🪙', label:'Gold Coin',     x:0.58, y:0.38, scale:1.0 },
      { emoji:'⌚', label:'Rolex',         x:0.35, y:0.55, scale:0.9 },
      { emoji:'💎', label:'Diamond Ring',  x:0.52, y:0.52, scale:0.85},
    ];

    // PARTICLES (embers + drips)
    const embers = [];
    const drips  = [];

    function mkEmber(x, y){
      return {
        x, y,
        vx:(Math.random()-0.5)*1.2,
        vy:-(0.5+Math.random()*2.5),
        life:1, decay:0.008+Math.random()*0.018,
        r:1+Math.random()*2.5,
        col: Math.random()>0.5 ? '#F5CC60' : '#FF6B00'
      };
    }
    function mkDrip(x){
      return {
        x: x + (Math.random()-0.5)*30,
        y: H()*0.55,
        vy: 0.8+Math.random()*2.5,
        r: 2+Math.random()*4,
        life:1, decay:0.012+Math.random()*0.015,
        col:'#C9982A'
      };
    }

    // Pool particles (bubbles)
    const bubbles = Array.from({length:18},()=>({
      x:0.5, y:0.72,
      vx:(Math.random()-0.5)*0.003,
      vy:-(0.0005+Math.random()*0.002),
      r:2+Math.random()*5,
      op:0.4+Math.random()*0.5
    }));

    function easeInOut(t){ return t<0.5?2*t*t:1-2*(1-t)*(1-t); }
    function lerp(a,b,t){ return a+(b-a)*t; }
    function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }

    function getStage(elapsed){
      let acc = 0;
      for(let i=0;i<STAGES.length;i++){
        acc += STAGES[i].dur;
        if(elapsed < acc){
          const prev = acc - STAGES[i].dur;
          return { idx:i, name:STAGES[i].id, t: clamp((elapsed-prev)/STAGES[i].dur, 0, 1) };
        }
      }
      return { idx:STAGES.length-1, name:'bar', t:1 };
    }

    // Draw a rounded rect
    function rr(x,y,w,h,r){
      ctx.beginPath();
      ctx.moveTo(x+r,y);
      ctx.lineTo(x+w-r,y);
      ctx.arcTo(x+w,y,x+w,y+r,r);
      ctx.lineTo(x+w,y+h-r);
      ctx.arcTo(x+w,y+h,x+w-r,y+h,r);
      ctx.lineTo(x+r,y+h);
      ctx.arcTo(x,y+h,x,y+h-r,r);
      ctx.lineTo(x,y+r);
      ctx.arcTo(x,y,x+r,y,r);
      ctx.closePath();
    }

    // Draw molten blob (wavy pool shape)
    function drawPool(cx, cy, w, h, wobble, opacity){
      ctx.save();
      ctx.globalAlpha = opacity;
      const points = 32;
      ctx.beginPath();
      for(let i=0;i<=points;i++){
        const a = (i/points)*Math.PI*2;
        const wob = 1 + wobble * Math.sin(a*4 + Date.now()*0.003) * 0.12;
        const px = cx + Math.cos(a)*w*wob;
        const py = cy + Math.sin(a)*h*wob*0.4;
        i===0 ? ctx.moveTo(px,py) : ctx.lineTo(px,py);
      }
      ctx.closePath();
      const g = ctx.createRadialGradient(cx,cy-h*0.1,0, cx,cy,w);
      g.addColorStop(0,'#FFD060');
      g.addColorStop(0.4,'#C9982A');
      g.addColorStop(0.7,'#8A5800');
      g.addColorStop(1,'rgba(80,30,0,0)');
      ctx.fillStyle = g;
      ctx.fill();
      // glow
      ctx.shadowColor = '#E8B840';
      ctx.shadowBlur = 40*opacity;
      ctx.fill();
      ctx.restore();
    }

    // Draw gold bar
    function drawBar(cx, cy, progress, opacity){
      const maxW = W()*0.22, maxH = H()*0.10;
      const bw = maxW * progress, bh = maxH * progress;
      if(bw < 2) return;
      ctx.save();
      ctx.globalAlpha = opacity;

      // bar body
      const g = ctx.createLinearGradient(cx-bw/2, cy-bh/2, cx-bw/2, cy+bh/2);
      g.addColorStop(0,'#FFE080');
      g.addColorStop(0.25,'#C9982A');
      g.addColorStop(0.5,'#FFD060');
      g.addColorStop(0.75,'#8A6010');
      g.addColorStop(1,'#C9982A');
      ctx.fillStyle = g;
      ctx.shadowColor = '#E8B840';
      ctx.shadowBlur = 30*opacity;
      rr(cx-bw/2, cy-bh/2, bw, bh, 4*progress);
      ctx.fill();

      // shine streak
      ctx.globalAlpha = opacity*0.4;
      const sg = ctx.createLinearGradient(cx-bw/2,cy-bh/2, cx+bw/2,cy+bh/2);
      sg.addColorStop(0,'rgba(255,255,255,0)');
      sg.addColorStop(0.4,'rgba(255,255,255,0.6)');
      sg.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle = sg;
      rr(cx-bw/2, cy-bh/2, bw*0.35, bh, 4*progress);
      ctx.fill();

      // "GOLD" text
      if(progress > 0.7){
        ctx.globalAlpha = opacity*(progress-0.7)/0.3;
        ctx.font = `bold ${Math.floor(bh*0.36)}px DM Sans,sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(80,40,0,0.7)';
        ctx.fillText('GOLD', cx, cy);
      }

      ctx.restore();
    }

    // Ambient embers always falling
    function spawnAmbientEmbers(stage, t){
      if(stage==='heat'||stage==='melt'||stage==='pool'){
        if(Math.random()<0.3){
          ITEMS.forEach(item=>{
            embers.push(mkEmber(W()*item.x, H()*item.y));
          });
        }
      }
    }

    let lastT = 0;
    function frame(now){
      if(!cycleStart) cycleStart = now;
      const elapsed = ((now - cycleStart) % CYCLE) / CYCLE;
      const s = getStage(elapsed);
      const dt = now - lastT; lastT = now;

      const w = W(), h = H();
      ctx.clearRect(0,0,w,h);

      // ── BACKGROUND ──
      // Dark base
      ctx.fillStyle = '#080604';
      ctx.fillRect(0,0,w,h);

      // Ambient warm glow that intensifies during melt
      let glowIntensity = 0;
      if(s.name==='heat') glowIntensity = s.t*0.12;
      else if(s.name==='melt') glowIntensity = 0.12+s.t*0.18;
      else if(s.name==='pool') glowIntensity = 0.30+Math.sin(now*0.003)*0.05;
      else if(s.name==='form') glowIntensity = 0.25*(1-s.t*0.5);
      else if(s.name==='bar') glowIntensity = 0.08+s.t*0.06;

      if(glowIntensity>0){
        const bg = ctx.createRadialGradient(w*0.5,h*0.8,0, w*0.5,h*0.5,w*0.6);
        bg.addColorStop(0,`rgba(255,120,0,${glowIntensity})`);
        bg.addColorStop(0.5,`rgba(180,80,0,${glowIntensity*0.4})`);
        bg.addColorStop(1,'rgba(0,0,0,0)');
        ctx.fillStyle = bg;
        ctx.fillRect(0,0,w,h);
      }

      // Subtle grid
      ctx.save();
      ctx.strokeStyle = 'rgba(201,152,42,0.04)';
      ctx.lineWidth = 1;
      for(let x=0;x<w;x+=60){ ctx.beginPath(); ctx.moveTo(x,0); ctx.lineTo(x,h); ctx.stroke(); }
      for(let y=0;y<h;y+=60){ ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(w,y); ctx.stroke(); }
      ctx.restore();

      // ── PARTICLES: embers ──
      spawnAmbientEmbers(s.name, s.t);
      for(let i=embers.length-1;i>=0;i--){
        const e=embers[i];
        e.x+=e.vx; e.y+=e.vy; e.vy+=0.04; e.life-=e.decay;
        if(e.life<=0){ embers.splice(i,1); continue; }
        ctx.save();
        ctx.globalAlpha=e.life*0.8;
        ctx.fillStyle=e.col;
        ctx.shadowColor=e.col;
        ctx.shadowBlur=e.r*5;
        ctx.beginPath(); ctx.arc(e.x,e.y,e.r,0,Math.PI*2); ctx.fill();
        ctx.restore();
      }

      // ── DRIP PARTICLES during melt ──
      if(s.name==='melt'&&s.t>0.1){
        if(Math.random()<0.15) ITEMS.forEach(item=>drips.push(mkDrip(w*item.x)));
      }
      for(let i=drips.length-1;i>=0;i--){
        const d=drips[i];
        d.y+=d.vy; d.vy+=0.08; d.life-=d.decay;
        if(d.y>h*0.78||d.life<=0){ drips.splice(i,1); continue; }
        ctx.save();
        ctx.globalAlpha=d.life*0.9;
        ctx.fillStyle=d.col;
        ctx.shadowColor='#E8B840'; ctx.shadowBlur=8;
        ctx.beginPath(); ctx.arc(d.x,d.y,d.r,0,Math.PI*2); ctx.fill();
        ctx.restore();
      }

      // ── DRAW ITEMS ──
      const itemsOpacity = (()=>{
        if(s.name==='items') return easeInOut(s.t);
        if(s.name==='heat') return 1;
        if(s.name==='melt') return 1-easeInOut(s.t);
        return 0;
      })();

      if(itemsOpacity>0.01){
        ITEMS.forEach((item, i)=>{
          const ix = w*item.x, iy = h*item.y;
          // during melt, items drift down and shrink
          const meltDrop = s.name==='melt' ? easeInOut(s.t)*h*0.18 : 0;
          const meltScale = s.name==='melt' ? 1-easeInOut(s.t)*0.5 : 1;
          // stagger appearance
          const stagger = clamp((s.name==='items'?s.t*5-i*0.8:1),0,1);

          ctx.save();
          ctx.globalAlpha = itemsOpacity*stagger;
          ctx.translate(ix, iy+meltDrop);
          ctx.scale(meltScale*item.scale, meltScale*item.scale);

          // glow
          if(s.name==='heat'||s.name==='melt'){
            ctx.shadowColor='#FF8C00';
            ctx.shadowBlur=20+Math.sin(now*0.005+i)*10;
          }

          // card bg
          ctx.fillStyle='rgba(10,8,4,0.7)';
          ctx.strokeStyle='rgba(201,152,42,0.6)';
          ctx.lineWidth=1.5;
          rr(-52,-26,104,52,6);
          ctx.fill(); ctx.stroke();

          // left accent
          ctx.fillStyle='#C9982A';
          ctx.fillRect(-52,-22,3,44);

          // emoji
          ctx.font='22px serif';
          ctx.textAlign='left';
          ctx.textBaseline='middle';
          ctx.shadowBlur=0;
          ctx.fillText(item.emoji,-38,0);

          // label
          ctx.font='600 11px DM Sans,sans-serif';
          ctx.fillStyle='#F0EBE0';
          ctx.textAlign='left';
          ctx.fillText(item.label,-12,-9);

          // "We Buy This"
          ctx.font='10px DM Sans,sans-serif';
          ctx.fillStyle='#C9982A';
          ctx.fillText('We Buy This',-12,8);

          ctx.restore();
        });
      }

      // ── MOLTEN POOL ──
      const poolCx = w*0.5, poolCy = h*0.72;
      if(s.name==='pool'){
        const poolW = w*0.22*easeInOut(s.t);
        const poolH = h*0.06;
        drawPool(poolCx, poolCy, poolW, poolH, 1, 0.6+s.t*0.3);

        // bubbles
        bubbles.forEach(b=>{
          b.x = clamp(b.x+b.vx,0.3,0.7);
          b.y = clamp(b.y+b.vy,0.6,0.78);
          if(b.y<0.62||b.y>0.78) b.vy*=-1;
          ctx.save();
          ctx.globalAlpha=b.op*0.4*s.t;
          ctx.fillStyle='#FFD060';
          ctx.shadowColor='#FFD060'; ctx.shadowBlur=10;
          ctx.beginPath(); ctx.arc(w*b.x,h*b.y,b.r,0,Math.PI*2); ctx.fill();
          ctx.restore();
        });
      }

      // Pool fading during form stage
      if(s.name==='form'){
        const poolW = w*0.22*(1-s.t*0.5);
        drawPool(poolCx, poolCy, poolW, h*0.05, 0.5, (1-s.t)*0.7);
      }

      // ── BAR FORMING ──
      if(s.name==='form'){
        const barCx = w*0.5, barCy = h*0.72;
        drawBar(barCx, barCy, easeInOut(s.t), easeInOut(s.t));
      }
      if(s.name==='bar'){
        const barCx = w*0.5, barCy = h*0.72;
        // pulse glow
        const pulse = 0.85+Math.sin(now*0.004)*0.15;
        drawBar(barCx, barCy, 1, pulse);

        // "999.9 FINE GOLD" text below bar
        const op = clamp((s.t-0.3)/0.4,0,1);
        if(op>0){
          ctx.save();
          ctx.globalAlpha = op*0.8;
          ctx.font = `600 ${Math.floor(h*0.018)}px DM Sans,sans-serif`;
          ctx.textAlign = 'center';
          ctx.fillStyle = '#E8B840';
          ctx.fillText('999.9 FINE GOLD · 1 TROY OZ', barCx, barCy + h*0.08);
          ctx.restore();
        }
      }

      // ── AMBIENT PARTICLES (always) ──
      if(Math.random()<0.08){
        embers.push(mkEmber(
          Math.random()*w,
          h*0.7+Math.random()*h*0.3
        ));
      }

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

} catch(err){ console.warn('Canvas error:',err); }
})();

// ── TRADINGVIEW WIDGET LOADER ──
// Loads TradingView ticker tape into #tv-widget-container if present
(function(){
  const container = document.getElementById('tv-widget-container');
  if(!container) return;

  // Create widget container
  const wrapper = document.createElement('div');
  wrapper.className = 'tradingview-widget-container';
  wrapper.style.cssText = 'height:46px;overflow:hidden;';

  const widgetDiv = document.createElement('div');
  widgetDiv.className = 'tradingview-widget-container__widget';
  wrapper.appendChild(widgetDiv);

  // Load TradingView script properly (not via innerHTML)
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
  script.async = true;
  script.textContent = JSON.stringify({
    "symbols": [
      {"description":"Gold","proName":"TVC:GOLD"},
      {"description":"Silver","proName":"TVC:SILVER"},
      {"description":"Platinum","proName":"TVC:PLATINUM"},
      {"description":"Palladium","proName":"TVC:PALLADIUM"},
      {"description":"Copper","proName":"COMEX:HG1!"}
    ],
    "showSymbolLogo": false,
    "isTransparent": true,
    "displayMode": "compact",
    "colorTheme": "dark",
    "locale": "en"
  });

  wrapper.appendChild(script);
  container.appendChild(wrapper);
})();